import { Switch } from '@webapp/common/components/switch';

import css from './filters-switch.css';

export const FiltersSwitch: FC<{
    onChange: (enabled: boolean) => void;
    defaultChecked: boolean;
    label: string;
    disabled?: boolean;
}> = ({ defaultChecked, onChange, disabled, label }) => {
    return (
        <div className={css.withFilters}>
            <Switch defaultChecked={defaultChecked} disabled={disabled} label={label} onChange={onChange} />
        </div>
    );
};
